var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30867",
    "data-name": "Path 30867",
    d: "M0,0H48V48H0Z",
    fill: "#c7cdd1",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card_security",
    "data-name": "card security",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27784",
    "data-name": "Group 27784",
    transform: "translate(12.016 9.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30882",
    "data-name": "Path 30882",
    d: "M619.525,1017.63a51.178,51.178,0,0,1-.147,5.8.282.282,0,0,1-.01.09,34.079,34.079,0,0,1-.451,3.47.36.36,0,0,1-.02.1,24.566,24.566,0,0,1-.637,2.73c-.049.15-.1.29-.157.44a6.354,6.354,0,0,1-.313.7c-.059.11-.118.22-.186.34a5.767,5.767,0,0,1-.421.66c-.137.2-.284.39-.431.58a.443.443,0,0,1-.059.07,6.379,6.379,0,0,1-.539.62,4,4,0,0,1-.284.3,24.239,24.239,0,0,1-5.27,3.97c-.206.12-.323.18-.323.18v-.01c-1.43-.84-6.838-4.24-7.817-7.72a48.312,48.312,0,0,1-1.391-13.36l9.2-2.99,9.218,2.99s.02.26.029.73A3.1,3.1,0,0,1,619.525,1017.63Z",
    transform: "translate(-597.845 -1010.08)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30883",
    "data-name": "Path 30883",
    d: "M622.613,1013.99l-12.362-3.91-12.353,3.91s-.764,9.62,1.577,17.09c1.783,5.7,10.785,10.18,10.785,10.18s9.081-4.88,10.619-10.18A58,58,0,0,0,622.613,1013.99Zm-3.056,16.37c-1.509,4.94-8.718,8.69-9.022,8.84l-.343.18-.333-.19c-.313-.17-7.582-4.22-8.885-8.85a49.84,49.84,0,0,1-1.42-14.34l.029-.52,10.619-3.46,10.619,3.45.039.51C620.879,1016.31,621.457,1024.13,619.556,1030.36Z",
    transform: "translate(-597.778 -1010.08)",
    fill: "#ffb063"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_30875",
    "data-name": "Path 30875",
    transform: "translate(12.423 3.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30884",
    "data-name": "Path 30884",
    d: "M619.57,1023.43a.282.282,0,0,1-.01.09,34.079,34.079,0,0,1-.451,3.47.36.36,0,0,1-.02.1,24.566,24.566,0,0,1-.637,2.73c-.049.15-.1.29-.157.44a6.354,6.354,0,0,1-.313.7c-.059.11-.118.22-.186.34a5.767,5.767,0,0,1-.421.66c-.137.2-.284.39-.431.58a.443.443,0,0,1-.059.07,6.379,6.379,0,0,1-.539.62,4,4,0,0,1-.284.3,24.239,24.239,0,0,1-5.27,3.97c-.206.12-.323.18-.323.18v-.01l-.01-24.07,9.218,2.99s.02.26.029.73a3.1,3.1,0,0,1,.01.31A51.178,51.178,0,0,1,619.57,1023.43Z",
    transform: "translate(-610.46 -1013.6)",
    fill: "#102d6f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.18310d8df93b22117b51f6225a4c2a7f.svg";
export { ForwardRef as ReactComponent };